import { FaUserNurse } from "react-icons/fa"

const AddNurseButton = ({ onClick }) => (
	<button
		className="h-9 bg-gray-100 text-dark text-sm font-semibold px-4 m-1 rounded flex items-center"
		onClick={onClick}
	>
		<FaUserNurse className="mr-2 w-4 h-4 text-dark" />
		Add Nurse
	</button>
)

export default AddNurseButton
